/**
 * ÉCLAT FINE JEWELRY - HIGH-RESOLUTION GALLERY WITH LENS ZOOM & MOBILE TOUCH SWIPE
 */

class LuxuryProductGallery {
  constructor(container) {
    this.container = container;
    this.mainImage = container.querySelector('.pdp-gallery__main-image');
    this.lens = container.querySelector('.pdp-gallery__lens-zoom');
    this.thumbnails = Array.from(container.querySelectorAll('.pdp-gallery__thumb'));
    this.wrapper = container.querySelector('.pdp-gallery__main-wrapper');
    this.currentIndex = 0;

    this.init();
  }

  init() {
    // 1. Thumbnail switching
    this.thumbnails.forEach((thumb, idx) => {
      thumb.addEventListener('click', () => {
        this.goToImage(idx);
      });
    });

    // 2. Desktop Interactive Magnifier Zoom
    if (this.wrapper && this.lens) {
      this.wrapper.addEventListener('mouseenter', () => {
        if (window.innerWidth > 768) {
          this.lens.style.opacity = '1';
          this.lens.style.backgroundImage = `url(${this.mainImage.src})`;
        }
      });

      this.wrapper.addEventListener('mouseleave', () => {
        this.lens.style.opacity = '0';
      });

      this.wrapper.addEventListener('mousemove', (e) => {
        if (window.innerWidth <= 768) return;
        const rect = this.wrapper.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const xPercent = (x / rect.width) * 100;
        const yPercent = (y / rect.height) * 100;

        this.lens.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
        this.lens.style.backgroundSize = '250%';
      });
    }

    // 3. Mobile Touch Swipe
    if (this.wrapper && this.thumbnails.length > 1) {
      let touchStartX = 0;
      let touchEndX = 0;

      this.wrapper.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      this.wrapper.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        this.handleSwipe(touchStartX, touchEndX);
      }, { passive: true });
    }
  }

  handleSwipe(startX, endX) {
    const diff = startX - endX;
    if (Math.abs(diff) > 40) {
      if (diff > 0) {
        // Swipe left -> next image
        const nextIdx = (this.currentIndex + 1) % this.thumbnails.length;
        this.goToImage(nextIdx);
      } else {
        // Swipe right -> previous image
        const prevIdx = (this.currentIndex - 1 + this.thumbnails.length) % this.thumbnails.length;
        this.goToImage(prevIdx);
      }
    }
  }

  goToImage(idx) {
    if (!this.thumbnails[idx]) return;
    this.currentIndex = idx;
    this.thumbnails.forEach(t => t.classList.remove('is-active'));
    this.thumbnails[idx].classList.add('is-active');

    const newSrc = this.thumbnails[idx].dataset.fullSrc;
    const newZoomSrc = this.thumbnails[idx].dataset.zoomSrc || newSrc;
    if (newSrc && this.mainImage) {
      this.mainImage.src = newSrc;
      if (this.lens) {
        this.lens.style.backgroundImage = `url(${newZoomSrc})`;
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.pdp-gallery');
  if (gallery) {
    new LuxuryProductGallery(gallery);
  }
});
